import { render, staticRenderFns } from "./DynamicListTable.vue?vue&type=template&id=13536060"
import script from "./DynamicListTable.vue?vue&type=script&lang=js"
export * from "./DynamicListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports